import { useQuery } from "react-query";
import { GET_CLINICAL_APPROACH, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getClinicalApproach } from "api/clinicalManagement";
import extractRecords from "../utils/extractRecords";

export interface ClinicalApproachRecord extends Record<string, unknown> {
  an_internal_id?: number;
  created_at?: string;
  end_date?: string;
  treatment_focus_area?: string;
  terminal_objective?: string;
  is_graduation_objective?: boolean;
}

const useGetClinicalApproach = (clientId: number | null) => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_CLINICAL_APPROACH, clientId],
    () => getClinicalApproach(clientId),
    {
      staleTime: STALE_TIME_5_MINUTES,
      enabled: Boolean(clientId),
      refetchOnWindowFocus: false,
    }
  );

  const records = extractRecords<ClinicalApproachRecord>(data);

  const clinicalApproach = records.length > 0 ? records[0] : null;

  return {
    clinicalApproach,
    clinicalApproachRecords: records,
    clinicalApproachLoading: isLoading,
    refetchClinicalApproach: refetch,
    ...rest,
  };
};

export default useGetClinicalApproach;
